export const splashTextConfig: any = {
  details: {
    text: `           Stell dir vor, du reist durch die Sterne – und jeder Planet erzählt dir seine eigene Geschichte.
  In diesem Kosmos findest du ganze Orbits sozialer Organisationen. Ihre Planeten sind spannende 
  Projekte, die darauf warten, entdeckt zu werden.
  
  Klick dich hinein, erfahre, was ein Planet zu bieten hat, was er noch sucht, und lande mit deiner 
  Crew mitten im Geschehen.
  
  Werde Bewohner:in, teile Ideen im Bordfunk, unterstütze mit einer Spende oder hinterlasse ein 
  kosmisches Like.
  
  Aus vielen kleinen Sternen entsteht so eine große Gemeinschaft – bereit, Funken der Veränderung
  in neue Welten zu tragen.
  
  Mach dich bereit, Raumreisende:r – dein Abenteuer beginnt jetzt!`,
  mobile_text: `           Stell dir vor, du reist durch die Sterne – und jeder Planet erzählt dir
   seine eigene Geschichte.In diesem Kosmos findest du ganze Orbits sozialer 
   Organisationen.Ihre Planeten sind spannende Projekte, die darauf warten, 
   entdeckt zu werden.
  
  Klick dich hinein, erfahre, was ein Planet zu bieten hat, was er noch sucht,
  und lande mit deiner Crew mitten im Geschehen.
  
  Werde Bewohner:in, teile Ideen im Bordfunk, unterstütze mit einer Spende
  oder hinterlasse ein kosmisches Like.
  
  Aus vielen kleinen Sternen entsteht so eine große Gemeinschaft – bereit, 
  Funken der Veränderung in neue Welten zu tragen.
  
  Mach dich bereit, Raumreisende:r – dein Abenteuer beginnt jetzt!`,
    font_size: 0.15,
    position: [-2.5, 1.7, 0],
    height: 3.2,
    width: 8,
    mobile_position: [0, 8, 0],
    mobile_font_size: 0.4,
    mobile_height: 8.5,
    mobile_width: 14.5,
  },
  //   info: {
  //     text: `    Stell dir vor, du reist durch ein Universum, in dem jede Umlaufbahn von einer Organisation 
  // gestaltet wird. In ihrem Orbit kreisen die Planeten – soziale Projekte, die Geschichten erzählen: wer
  // sie sind, was sie anbieten und was sie noch brauchen. 

  // Als Reisender kannst du auf diesen Planeten landen, dich umschauen, liken, unterstützen oder sogar 
  // Bewohner:in werden. Bewohner:innen treten miteinander in Kontakt – im Bordfunk, über geteilte 
  // Bilder und Ideen. Auf der Timeline entdeckst du alle Neuigkeiten und Entwicklungen rund um den 
  // Planeten.

  // So entsteht aus vielen einzelnen Sternen eine große Gemeinschaft. Hier werden Projekte nicht nur 
  // finanziell gestärkt, sondern auch durch Austausch lebendig gehalten. Manche Funken springen über 
  // und entzünden neue Projekte in anderen Städten – getragen von einer galaktischen Crew, die 
  // zusammen Großes bewegt. 
  // `,
  // font_size: 0.15,

  // position: [-2.5, 1.7, 0],

  // height: 3.2,
  // width: 8,
  //   },
  close: {
    text: "Let's Go",
    mobile_text:"Let's Go",
    font_size: 0.123,
    position: [0.6, 0.4, 0],
    mobile_position: [0, 5, 0],
    height: 0.4,
    width: 1.7,
    mobile_font_size: 0.4,
    mobile_height: 1.5,
    mobile_width: 4
  }
}
